import React from "react";

function MenuTitle() {
    return <h1 className="menu__title">AudioHut</h1>;
}

export default MenuTitle;
